import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import baseApi from "../../api/baseApi";

import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialState = {
  package: {},
  packageLoading: true,
  packageRefresh: true,

  packages: [],
  packagesLoading: true,
  packagesRefresh: true,

  createPackageLoading: false,
  updatePackageLoading: false,
  deletePackageLoading: false,
};

export const fetchPackage = createAsyncThunk(
  "package/fetchPackage",
  async (id) => {
    if (!id) throw new Error("Id bulunamadı!");

    try {
      const response = await baseApi.get(`/Package/${id}`);

      return response.data.Value;
    } catch (error) {
      throw new Error(
        error.response?.data?.Error?.Description || error.response?.status
      );
    }
  }
);

export const fetchPackages = createAsyncThunk(
  "package/fetchPackages",
  async () => {
    try {
      const response = await baseApi.get(`/Package`);

      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.Error?.Description ||
          error.response?.status ||
          error.response?.data?.errorMessage
      );
    }
  }
);

export const packageSlice = createSlice({
  name: "package",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackage.pending, (state, action) => {
        state.package = {};
        state.packageLoading = true;
      })
      .addCase(fetchPackage.fulfilled, (state, action) => {
        state.package = action.payload;
        state.packageLoading = false;
      })
      .addCase(fetchPackage.rejected, (state, action) => {
        state.package = {};
        state.packageLoading = false;
      });

    builder
      .addCase(fetchPackages.pending, (state, action) => {
        state.packages = [];
        state.packagesLoading = true;
      })
      .addCase(fetchPackages.fulfilled, (state, action) => {
        state.packages = action.payload;
        state.packagesLoading = false;
      })
      .addCase(fetchPackages.rejected, (state, action) => {
        state.packages = [];
        state.packagesLoading = false;
      });
  },
});

export default packageSlice.reducer;
